import { axiosRequest } from '@/plugins/axios-common'
import { dateDisplayFormat } from '@/utilities'
import { handleError } from '@/store/handle-error'

// Time until cached items are considered expired and need to be reloaded
const CACHE_TTL = 2 * 1000

export const DocketEntriesInfoState = {
  docketEntriesInfo: {
    items: {},
    dateLastUpdated: 0,
    legalCaseId: undefined,
    promiseHandle: undefined,
  },
}

export const DocketEntriesInfoActions = {
  deleteDocketEntryInfo ({ commit }, docketEntryId) {
    commit('setDocketEntryInfoDeleted', docketEntryId)
  },

  removeDocketEntryInfoRelations ({ commit }, docketEntryId) {
    commit('setDocketEntryInfoRelationless', docketEntryId)
  },

  loadDocketEntriesInfo ({ commit, state }, requestData) {
    if (
      state.docketEntriesInfo.legalCaseId === requestData.legalCaseId &&
      state.docketEntriesInfo.dateLastUpdated + CACHE_TTL > Date.now()
    ) return

    if (!state.docketEntriesInfo.promiseHandle) {
      state.docketEntriesInfo.promiseHandle = axiosRequest.get(
      `/legal_cases/${requestData.legalCaseId}/docket_entries_info`,
      {
        params: {
          last_modified: state.docketEntriesInfo.dateLastUpdated,
          total: Object.keys(state.docketEntriesInfo.items).length,
        },
      }
      ).
        then(({ data }) => {
          commit('setDocketEntriesInfo', { response: data, legalCaseId: requestData.legalCaseId })
        }).
        catch(handleError).
        finally(_ => { state.docketEntriesInfo.promiseHandle = undefined })
    }

    return state.docketEntriesInfo.promiseHandle
  },

  refreshDocketEntriesInfo ({ commit, state }, requestData) {
    if (!state.docketEntriesInfo.promiseHandle) {
      state.docketEntriesInfo.promiseHandle = axiosRequest.get(
      `/legal_cases/${requestData.legalCaseId}/docket_entries_info`,
      {
        params: {
          last_modified: state.docketEntriesInfo.dateLastUpdated,
          total: Object.keys(state.docketEntriesInfo.items).length,
        },
      }
      ).
        then(({ data }) => {
          commit('setDocketEntriesInfo', { response: data, legalCaseId: requestData.legalCaseId })
        }).
        catch(handleError).
        finally(_ => { state.docketEntriesInfo.promiseHandle = undefined })
    }
  },
}

export const DocketEntriesInfoMutations = {
  setDocketEntriesInfo: (state, { response, legalCaseId }) => {
    state.docketEntriesInfo.legalCaseId = legalCaseId
    state.docketEntriesInfo.items = response.items
    state.docketEntriesInfo.dateLastUpdated = response.last_modified
  },

  setDocketEntryInfoDeleted: (state, docketEntryId) => {
    if (!Object.keys(state.docketEntriesInfo.items).includes(`${docketEntryId}`)) return
    const entry = state.docketEntriesInfo.items[`${docketEntryId}`]
    entry.deleted = true
  },

  setDocketEntryInfoRelationless: (state, docketEntryId) => {
    if (!Object.keys(state.docketEntriesInfo.items).includes(`${docketEntryId}`)) return
    const entry = state.docketEntriesInfo.items[`${docketEntryId}`]
    entry.has_relations = false
  },
}

export const DocketEntriesInfoGetters = {
  docketEntriesInfo: state => state.docketEntriesInfo.items,
  docketEntriesInfoLegalCaseId: state => state.docketEntriesInfo.legalCaseId,
  docketEntriesInfoList: state => Object.keys(state.docketEntriesInfo.items).map(k => {
    const info = state.docketEntriesInfo.items[k]

    return {
      text: `${info.action_type} #${k} - ${info.title} (${dateDisplayFormat(info.action_date)})`,
      value: Number(k),
      disabled: info.deleted,
    }
  }),
}
